import ServerInstance from "./server.api";

class ReviewEndpoint extends ServerInstance {
    async create(formData) {
        try {
            const response = await this.post("review", formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async replyReview(reviewId, replyData) {
        try {
            const response = await this.post(`review/${reviewId}/reply`, replyData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default ReviewEndpoint;
